import React from 'react';
import { makeStyles } from '@material-ui/core';

import Logo from '@root/assets/logo/white.svg';
import adIllustration from '@root/assets/copysmith-workflow-large.png';

const useStyles = makeStyles(() => ({
  logoStyle: {
    width: '33px',
    borderRadius: '50%',
    border: '2px solid white',
    boxShadow: '0 0 0 2px #E34C5F',
  },
  companyInfoContainer: {
    position: 'relative',
  },
  companyHeaderContainer: {
    position: 'absolute',
    left: '2.825rem',
    top: 0,
    fontFamily: 'Helvetica Neue, Inter, sans-serif',
    lineHeight: '1.125rem',
  },
  companyNameStyle: {
    fontSize: '0.975rem',
  },
  companySponsoredStyle: {
    fontSize: '0.8rem',
  },
  adIllustration: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '0.825rem',
    borderTop: '1px solid #DCDCDC',
    height: '260px',
    width: 'calc(100% + 40px)',
    marginLeft: '-20px',
  },
  learnMoreBanner: {
    position: 'relative',
    backgroundColor: '#F6746F',
    color: '#fff',
    fontSize: '0.9rem',
    borderBottom: '1px solid #DCDCDC',
    height: '40px',
    width: 'calc(100% + 56px)',
    marginLeft: '-28px',
  },
  learnMoreBannerText: {
    position: 'absolute',
    left: '20px',
    top: '8px',
  },
  arrowBannerText: {
    position: 'absolute',
    right: '20px',
    fontSize: '1.575rem',
  },
  emoticonContainer: {
    width: '110px',
    margin: '0.425rem 0 0.3rem -0.525rem',
  },
  likeTextStyle: {
    fontFamily: 'Helvetica Neue, Inter, sans-serif',
    fontSize: '0.95rem',
    marginBottom: '0.25rem',
  },
}));

const InstagramAdGraphic = ({
  companyName = '',
}) => {
  const classes = useStyles();
  return (
    <div>
      <div
        className={classes.companyInfoContainer}
      >
        <img
          src={Logo}
          alt="Copysmith Logo"
          className={classes.logoStyle}
        />
        <div className={classes.companyHeaderContainer}>
          <div className={classes.companyNameStyle}>
            <b>{companyName.toLowerCase()}</b>
          </div>
          <div className={classes.companySponsoredStyle}>Sponsored</div>
        </div>
      </div>

      <div className={classes.adIllustration}>
        <img
          src={adIllustration}
          alt="Paper airplane illustration"
          width="300px"
        />
      </div>

      <div className={classes.learnMoreBanner}>
        <span className={classes.learnMoreBannerText}>
          Learn More
        </span>
        <span className={classes.arrowBannerText}>
          ›
        </span>
      </div>

      <div>
        <img
          src="https://i.imgur.com/aYfxGkR.png"
          alt="Like, Comment, Share Emoticons"
          className={classes.emoticonContainer}
        />
      </div>
      <div className={classes.likeTextStyle}>
        <b>2140 likes</b>
      </div>
    </div>

  );
};

export default InstagramAdGraphic;
